import React from 'react';
import { Navbar, Dropdown } from 'react-bootstrap';
import { FaBars, FaCaretDown } from 'react-icons/fa';

const Topbar = ({ toggleSidebar, onLogout }) => (
  <Navbar bg="white" className="border-bottom px-3 py-2 d-flex justify-content-between">
    <div className="d-flex align-items-center">
      <button 
        className="btn btn-link text-dark p-0 me-3" 
        onClick={toggleSidebar}
        aria-label="Toggle sidebar"
      >
        <FaBars />
      </button>
    </div>
    <Dropdown align="end">
      <Dropdown.Toggle as="div" className="d-flex align-items-center text-secondary" style={{ cursor: 'pointer' }}>
        <span className="me-1">John Seth</span>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item href="#">Profile</Dropdown.Item>
        <Dropdown.Item onClick={onLogout}>Logout</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  </Navbar>
);

export default Topbar;